<template>
  <div
    v-show="false"
    class="print-unbreak"
    style="page-break-after: always !important; width: 100% !important; display: flex !important; flex-direction: row; flex-wrap: nowrap !important;"
  >
    <div
      v-for="copy in [1, 2]"
      :key="copy"
      :style="`width: 50%; ${copy === 1 ? 'border-right: 1px dashed #333;' : ''} padding: 6px; display: flex; flex-direction: column; flex-wrap: wrap;`"
    >
      <div
        style="display: flex; justify-content: space-between; flex-direction: row; flex-wrap: nowrap; width: 100%;"
      >
        <img
          v-if="tenant.profileImage"
          :style="`min-height: 55px !important; max-height: 55px !important; max-width: 120px !important; object-fit: contain;`"
          :src="tenant.profileImage"
          alt=""
        />
        <div style="display: flex; align-items: center; flex-direction: column; padding-right: 7px; padding-left: 7px;">
          <span class="font-head-title">
            {{ tenant.nome }}
          </span>
          <span class="font-head-subtitle" v-if="tenant.cnpj">
            CNPJ: {{ tenant.cnpj }}
          </span>
          <span
            v-if="tenant.address"
            class="font-head-subtitle"
            style="text-align: center;"
          >
            {{ tenant.address.formatted_address }}
          </span>
          <span class="font-head-subtitle" v-if="tenant.phone">
            {{ tenant.phone }}
          </span>
        </div>
        <div
          class="font-head-subtitle"
          style="font-size: 9pt; display: flex; width: 15%; justify-content: center;"
        >
          Via {{ copy }}
        </div>
      </div>

      <div
        class="mt-3"
        style="margin-top: 12px; display: flex; justify-content: center; align-items: baseline; flex-wrap: wrap; width: 100%;"
      >
        <span class="font-title">NOTA DE SAÍDA</span>
        <span class="font-head-subtitle" style="margin-left: 10px;">
          Venda Nº {{ lastSell.id_transacao || lastSell._id }}
        </span>
      </div>

      <div
        style="padding: 12px; display: flex; width: 100%; flex-direction: column; flex-wrap: wrap;"
      >
        <div style="display: flex; width: 100%;" v-if="client.nome">
          <span class="font-head-title" style="margin-right: 18px;">
            Cliente:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 80%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ client.nome }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;" v-if="client.telefone">
          <span class="font-head-title" style="margin-right: 6px;">
            Telefone:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 78%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ client.telefone }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            Tipo:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 84%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ movementLabel }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            Origem:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 78%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ originName }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            Destino:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 77%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ destinationName }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            Responsável:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 68%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ responsibleName }}
            </span>
          </div>
        </div>
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            Data:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 84%; border-bottom: 1px solid #f2f1f1;">
            <span class="font-head-subtitle">
              {{ issuedAt }}
            </span>
          </div>
        </div>
      </div>

      <table style="width: 100%; background: #f0f0f0; border-collapse: collapse;">
        <tr
          class="tr-table"
          style="width: 100%; background: #f7f7f7; border: 1px solid #f0f0f0;"
        >
          <td
            style="padding-right: 2px; text-align: center; padding-left: 2px; color: #878686; border-right: 1px solid #D2D4CF;"
          >
            <span class="font-head-title">QTD</span>
          </td>
          <td
            style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
          >
            <span class="font-head-title">D I S C R I M I N A Ç Ã O</span>
          </td>
          <td
            style="padding-right: 10px; padding-left: 10px; color: #878686; border-right: 1px solid #D2D4CF;"
          >
            <span class="font-head-title">MEDIDA</span>
          </td>
        </tr>
        <template v-for="(item, productIndex) in products">
          <tr
            style="background: #cccaca; border-bottom: 3px dashed #cccaca;"
            :key="`exit-desc-${copy}-${productIndex}`"
          >
            <td
              class="fonte fonte-micro"
              style="color: #cccaca; padding-right: 10px; padding-left: 10px;"
            >
              <span class="font-head-subtitle">---</span>
            </td>
            <td
              class="fonte fonte-micro"
              style="color: #cccaca; padding-right: 10px; padding-left: 10px; width: 70%;"
            >
              <span class="font-head-title">
                {{ item.descricao_personalizada ? item.descricao_personalizada : item.nome }}
              </span>
            </td>
            <td style="color: #cccaca">
              <span class="font-head-subtitle">---</span>
            </td>
          </tr>
          <tr
            v-for="(piece, pieceIndex) in item.ficha_tecnica || []"
            class="tr-table"
            style="background: #f0f0f0; width: 100%;"
            :key="`exit-piece-${copy}-${productIndex}-${pieceIndex}`"
            v-show="piece.quantity && piece.quantity >= 1"
          >
            <td
              class="fonte fonte-micro"
              style="color: #f7f7f7; text-align: center;"
            >
              <span class="font-head-title">
                {{ piece.quantity }}
              </span>
            </td>
            <td
              class="fonte fonte-micro"
              style="padding-right: 10px; padding-left: 10px;"
            >
              <span class="font-head-subtitle">
                {{ piece.descricao ? piece.descricao : "" }} - {{ item.nome }}
              </span>
            </td>
            <td
              class="fonte fonte-bold"
              style="padding-right: 15px; padding-left: 10px; text-wrap: nowrap;"
            >
              <span class="font-head-subtitle">
                {{ piece.comprimento || piece.largura ? `${formatMeasure(piece.comprimento)} x ${formatMeasure(piece.largura)}` : "##" }}
              </span>
            </td>
          </tr>
        </template>
      </table>

      <div style="display: flex; width: 100%; flex-direction: column; margin-top: 10px;">
        <div style="display: flex; width: 100%; margin-top: 4px;">
          <span class="font-head-title" style="margin-right: 6px;">
            OBS:
          </span>
          <div style="padding-left: 2px; display: flex; min-width: 88%; border-bottom: 1px solid #8f8e8e;">
            <span class="font-head-subtitle">
              {{ movement.note || "" }}
            </span>
          </div>
        </div>
      </div>

      <div style="display: flex; width: 100%; flex-wrap: nowrap; margin-top: auto; padding-top: 40px;">
        <div style="display: flex; width: 50%; flex-direction: column; align-items: center;">
          <div>
            ________________________________
          </div>
          <span class="text-head-title">
            ENTREGUE POR
          </span>
        </div>
        <div style="display: flex; width: 50%; flex-direction: column; align-items: center;">
          <div>
            ________________________________
          </div>
          <span class="text-head-title">
            RECEBIDO POR
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    lastSell: {
      type: Object,
      default: () => ({})
    },
    movement: {
      type: Object,
      default: () => ({})
    },
    getLoggedUser: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    tenant() {
      return (this.getLoggedUser.tenant && this.getLoggedUser.tenant[0]) || {};
    },
    client() {
      return (this.lastSell.compra && this.lastSell.compra.cliente) || this.lastSell.client || {};
    },
    products() {
      return (this.lastSell.compra && this.lastSell.compra.produtos) || [];
    },
    issuedAt() {
      return this.$moment(this.movement.sent_at || new Date()).format("DD/MM/YYYY HH:mm");
    },
    movementLabel() {
      if (this.movement.movement_scope === "unity") {
        return this.movement.movement_type_label || (this.movement.movement_type === "assembly" ? "Responsabilidade de montagem" : "Peça física");
      }
      return "Movimentação entre empresas";
    },
    originName() {
      return this.endpointName(this.movement.from_unity || this.movement.from_tenant);
    },
    destinationName() {
      return this.endpointName(this.movement.to_unity || this.movement.to_tenant);
    },
    responsibleName() {
      return this.userName(this.movement.responsible_user || this.movement.sender_user);
    }
  },
  methods: {
    endpointName(endpoint) {
      return (endpoint && endpoint.nome) || "Não informado";
    },
    userName(user) {
      return (user && user.nome) || "Não informado";
    },
    formatMeasure(value) {
      const number = Number(value || 0);
      return number ? `${number} cm` : "-";
    }
  }
};
</script>
